import { LoggedRoutingModule } from './logged-routing.module';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Modules
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ComponentModule } from './../components/component.module';
import { ListGroupComponent } from './../views/list-group/list-group.component';
import { DashboardClModule } from '../views/dashboard-cl/dashboard-cl.module';
// Components
import { MainComponent } from '../logged-module/components/main/main.component';
import { PersonTypeToggleComponent } from './components/main/person-type-toggle/person-type-toggle.component';
import { LanguageSelectorComponent } from '../components/language-selector/language-selector.component';
import { ProcessedTrackingRecordsFilesComponent } from '../views/processed-document-files/processed-tracking-records-files.component';
import { WalletFavoriteListComponent } from '../views/favorite/wallet-favorite-list/wallet-favorite-list.component';
import { RegistryFavoriteListComponent } from '../views/favorite/registry-favorite-list/registry-favorite-list.component';
import { ListIndividualComponent } from '../views/list-individual/list-individual.component';
import { AttributeEvolutionComponent } from '../views/attribute-evolution/attribute-evolution.component';
import { WalletDetailsComponent } from '../views/wallet-details/wallet-details.component';
import { WalletTrendComponent } from '../views/wallet-trend/wallet-trend.component';
import { FrequentQuestionComponent } from '../views/frequent-question/frequent-question.component';

@NgModule({
  declarations: [MainComponent],
  providers: [],
  imports: [
    LoggedRoutingModule,
    CommonModule,
    RouterModule,
    ComponentModule,
    DashboardClModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    ListGroupComponent,
    PersonTypeToggleComponent,
    LanguageSelectorComponent,
    ProcessedTrackingRecordsFilesComponent,
    WalletFavoriteListComponent,
    RegistryFavoriteListComponent,
    ListIndividualComponent,
    AttributeEvolutionComponent,
    WalletDetailsComponent,
    WalletTrendComponent,
    FrequentQuestionComponent,
  ],
  exports: [],
})
export class LoggedModule {}
